<template>
    <v-container fluid>
        <span style="width:100%;" v-for="(item,k) in this.$store.getters.getActiveBiomarker"  v-bind:key="k">
            <NavBar_Gene v-bind:item="item"></NavBar_Gene>
            <Loading v-model:active="isLoading" v-model="fullPage" :can-cancel="true" :is-full-page="fullPage" />
        </span>

        <div style="height:10px;"></div>
        <div style="border:0px solid #f5f5f5;">

                        <v-row align="center" justify="center" id="result-download">
                            <v-col cols="12" md="12" lg="12" xl="12" justify="center" align="center" style="">
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <div v-if="this.$store.getters.isLoading" class="loading-spinner">
                                  <div class="spinner"></div>
                                  <div>Loading</div>
                                </div>
                            </v-col>
                        </v-row>

                        <v-row>

                        <span style="width:100%;" v-for="(item, k) in this.$store.getters.getActiveBiomarker" v-bind:key="k">
                        <v-row align="center" justify="center" id="result-download">
                            <v-col cols="12" md="12" lg="11" xl="11" justify="center" align="center" style="">
                                <v-divider></v-divider>
                                <div style="margin-left:20px;text-align:left;">
                                    <p style="font-size:16px;">
                                        Protein Features
                                        <!--<v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                        id="icon-protein-features" @click="showTooltip('icon-protein-features','protein-features-description-main')" />-->
                                    </p>
                                    <p style="font-size:12px; margin-top:5px;">
                                        Known variants of the selected variant position and the surrounding area,
                                        relative accessible surface area (RSA) and the secondary structure
                                    </p>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row style="">
                            <v-col cols="12" md="12" lg="12" xl="12" justify="center" align="center" style="">
                                <v-row style="margin:0;padding:0;">
                                    <v-col cols="11" md="11" lg="11" xl="11" justify="center" align="center" style="">
                                        <div id="protein_plot" style="">
                                        </div>
                                        <div style="">
                                            <div id="protein_legend" style="margin:0;">
                                            </div>
                                        </div>
                                    </v-col>
                                    <v-col cols="1" md="1" lg="1" xl="1" justify="center" align="center" style="border:0px solid red;">
                                        <v-row style="height: 25%;">
                                            <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                        id="icon-protein-features-1" @click="showTooltip('icon-protein-features-1','protein-features-desc-variants')" />
                                        </v-row>
                                        <v-row style="height: 11%;">
                                            <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                        id="icon-protein-features-2" @click="showTooltip('icon-protein-features-2','protein-features-desc-relasa')" />
                                        </v-row>
                                        <v-row style="height: 11%;">
                                            <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                id="icon-protein-calpha"
                                                @click="showTooltip('icon-protein-calpha','protein-features-desc-calpha')"
                                             />
                                        </v-row>
                                        <v-row style="height: 10%;">
                                            <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                id="icon-protein-domains"
                                                @click="showTooltip('icon-protein-domains','protein-features-desc-domains')"
                                             />
                                        </v-row>
                                        <v-row style="height: 48%;">
                                            <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                        id="icon-protein-features-3" @click="showTooltip('icon-protein-features-3','protein-features-desc-secstruc')" />
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </span>

                        </v-row>

                        <v-row>


                            <!-- Protein structure viewers -->
                            <v-col cols="12" md="12" lg="12" xl="12" style="text-align:left;border:0px solid red;">

                                <span style="width:100%;" v-for="(item, k) in this.$store.getters.getActiveBiomarker" v-bind:key="k">
                                <div style="margin-left:20px;text-align:left;margin-bottom:10px;">
                                    <h3 class="text-h5 font-weight-light" style="margin:0;padding:0;">
                                        Protein Structure
                                        <span v-if="'UTA_Adapter_protein_sequence' in item">
                                            ({{ item.UTA_Adapter_protein_sequence.gene_name }})
                                        </span>
                                    </h3>
                                </div>
                                </span>

                                <v-row style="margin:0;padding:0;">

                                        <v-col cols="12" md="12" lg="8" xl="8" style="margin:0;padding:0;text-align:left;border:0px solid red;" align="center" justify="center">
                                        <!--<p style="padding-left:20px;">Pathogenicity</p>-->
                                        <div style="text-align:center;border:3px solid #f5f5f5;height:840px;">
                                            <div style="padding-top:10px; padding-bottom:5px;">
                                                    Pathogenicity
                                                    <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                        id="icon-binding-sites" @click="showTooltip('icon-binding-sites','binding-sites')" />
                                            </div>
                                            <div style="text-align:center;border:3px solid #f5f5f5;height:600px;padding:20px;">
                                                <div ref="viewerContainer0" id="viewerContainer0" data-ui="false" class="viewer_3Dmoljs"
                                                    style="border:0px solid red;width:100%;height:700px;position:relative;"
                                                >
                                                </div>
                                                <v-btn @click="dialog_protein_patho = true" eager>
                                                    Show
                                                    <span style="width:10px;" eager></span>
                                                    <v-icon icon="mdi-arrow-expand" eager />
                                                </v-btn>
                                            </div>
                                        </div>

                                        <v-dialog v-model="dialog_protein_patho" eager>
                                            <v-card style="width:100%;margin:auto;" eager>
                                                <v-btn @click="dialog_protein_patho = false" eager>Close</v-btn>
                                                <div style="height:20px;" eager></div>
                                                <!--<div id="chart-protein-patho" style="width:1000px;height:1200px;" eager></div>-->
                                                <div ref="viewerContainer4" id="viewerContainer4" data-ui="false" class="viewer_3Dmoljs"
                                                    style="border:0px solid red;width:100%;height:1200px;position:relative;" eager
                                                >
                                                </div>
                                            </v-card>
                                        </v-dialog>

                                    </v-col>
                                    <v-col cols="12" md="6" lg="4" xl="4" style="text-align:left;margin:0;padding:0;">
                                        <!--<p style="padding-left:20px;">Binding sites</p>-->
                                        <div style="text-align:center;border:3px solid #f5f5f5;height:420px;">
                                            <div style="padding-top:10px; padding-bottom:5px;">
                                                    Binding sites
                                                    <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                        id="icon-binding-sites" @click="showTooltip('icon-binding-sites','binding-sites')" />
                                            </div>
                                            <div style="text-align:center;border:3px solid #f5f5f5;height:420px;padding:20px;">
                                                <div ref="viewerContainer1" id="viewerContainer1" data-ui="true"
                                                    class="viewer_3Dmoljs"
                                                    style="border:0px solid red;width:600px;height:300px;position:relative;">
                                                </div>
                                                <v-btn @click="dialog_protein_binding = true" eager>
                                                    Show
                                                    <span style="width:10px;" eager></span>
                                                    <v-icon icon="mdi-arrow-expand" eager />
                                                </v-btn>
                                            </div>
                                        </div>

                                        <v-dialog v-model="dialog_protein_binding" eager>
                                            <v-card style="width:100%;margin:auto;" eager>
                                                <v-btn @click="dialog_protein_binding = false" eager>Close</v-btn>
                                                <div style="height:20px;" eager></div>
                                                <div ref="viewerContainer5" id="viewerContainer5" data-ui="false" class="viewer_3Dmoljs"
                                                    style="border:0px solid red;width:100%;height:1000px;position:relative;" eager
                                                ></div>
                                            </v-card>
                                        </v-dialog>


                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </div>
        <div style="height:10px;"></div>

    </v-container>
</template>
<script>
import Loading from 'vue-loading-overlay';
import NavBar_Gene from '@/components/navbars/NavBar_Gene';
import active_variants from "@/methods/active_variants";
import { ref } from 'vue';

import axios from 'axios';
import * as $3Dmol from '3dmol'
import '@/assets/js/3Dmol.ui-min.js'
import { mapGetters } from 'vuex'
//import load_protein_structures from "@/methods/load_protein_structures"
import Plotly from  '@/assets/js/plotly-latest.min.js';

export default {
    name: 'GeneProtein',
    components: {
        Loading,
        NavBar_Gene,
    },
    data: function () {
        return {
            isLoading: false,
            active_transcript: {},
            pseq: '',
            pmol: '',
            active_protein: '',
            prot_seq_cols: 5,
            dialog_protein_patho: false,
            dialog_protein_binding: false,
            protein_legend: {"data": [{"line": {"shape": "spline"}, "marker": {"color": "#2ca02c", "size": 3}, "mode": "lines+markers", "name": "lines+markers", "x": [0.0, 0.18181818181818182, 0.36363636363636365, 0.5454545454545454, 0.7272727272727273, 0.9090909090909092, 1.0909090909090908, 1.2727272727272727, 1.4545454545454546, 1.6363636363636365, 1.8181818181818183, 2.0], "y": [1, 2, 1, 0, 1, 2, 1, 0, 1, 2, 1, 0], "type": "scatter"}, {"line": {"shape": "spline"}, "marker": {"color": "#d62728", "size": 3}, "mode": "lines+markers", "name": "lines+markers", "x": [13.0, 13.181818181818182, 13.363636363636363, 13.545454545454545, 13.727272727272727, 13.90909090909091, 14.09090909090909, 14.272727272727273, 14.454545454545455, 14.636363636363637, 14.818181818181818, 15.0], "y": [1, 2, 1, 0, 1, 2, 1, 0, 1, 2, 1, 0], "type": "scatter"}, {"line": {"shape": "spline"}, "marker": {"color": "#e377c2", "size": 3}, "mode": "lines+markers", "name": "lines+markers", "x": [22.0, 22.181818181818183, 22.363636363636363, 22.545454545454547, 22.727272727272727, 22.90909090909091, 23.09090909090909, 23.272727272727273, 23.454545454545453, 23.636363636363637, 23.81818181818182, 24.0], "y": [1, 2, 1, 0, 1, 2, 1, 0, 1, 2, 1, 0], "type": "scatter"}, {"line": {"shape": "spline"}, "marker": {"color": "#8c564b", "size": 3}, "mode": "lines+markers", "name": "lines+markers", "x": [30.0, 30.181818181818183, 30.363636363636363, 30.545454545454547, 30.727272727272727, 30.90909090909091, 31.09090909090909, 31.272727272727273, 31.454545454545453, 31.636363636363637, 31.81818181818182, 32.0], "y": [1, 2, 1, 0, 1, 2, 1, 0, 1, 2, 1, 0], "type": "scatter"}, {"fill": "toself", "fillcolor": "#1f77b4", "hoverinfo": "skip", "line": {"color": "#1f77b4"}, "mode": "lines", "opacity": 1, "x": [45, 44, 44, 45], "y": [1, 1.8, 0.19999999999999996, 1], "type": "scatter"}, {"hoverinfo": "skip", "line": {"color": "#1f77b4", "width": 25}, "mode": "lines", "x": [43, 44], "y": [1, 1], "type": "scatter"}, {"hoverinfo": "text", "marker": {"color": "#1f77b4", "size": 3}, "text": ["B: Isolated beta-bridge residue<br>position: 43<br>"], "x": [43, 44, 45], "y": [1, 1, 1], "type": "scatter"}, {"fill": "toself", "fillcolor": "#9467bd", "hoverinfo": "skip", "line": {"color": "#9467bd"}, "mode": "lines", "opacity": 1, "x": [63, 62, 62, 63], "y": [1, 1.8, 0.19999999999999996, 1], "type": "scatter"}, {"hoverinfo": "skip", "line": {"color": "#9467bd", "width": 25}, "mode": "lines", "x": [61, 62], "y": [1, 1], "type": "scatter"}, {"hoverinfo": "text", "marker": {"color": "#9467bd", "size": 3}, "text": ["E: Strand<br>position: 61<br>"], "x": [61, 62, 63], "y": [1, 1, 1], "type": "scatter"}, {"hoverinfo": "text", "marker": {"color": "black", "size": 3}, "mode": "lines+markers", "text": ["-: None<br>position: 69<br>"], "x": [69, 70, 71], "y": [1, 1, 1], "type": "scatter"}, {"hoverinfo": "text", "marker": {"color": "#ff7f0e ", "size": 3}, "mode": "lines+markers", "text": ["S: Bend<br>position: 77<br>"], "x": [77, 78, 79], "y": [1, 1, 1], "type": "scatter"}, {"hoverinfo": "text", "marker": {"color": "#17becf", "size": 3}, "mode": "lines+markers", "text": ["T: Turn<br>position: 85<br>"], "x": [85, 86, 87], "y": [1, 1, 1], "type": "scatter"}], "layout": {"template": {"data": {"barpolar": [{"marker": {"line": {"color": "white", "width": 0.5}, "pattern": {"fillmode": "overlay", "size": 10, "solidity": 0.2}}, "type": "barpolar"}], "bar": [{"error_x": {"color": "#2a3f5f"}, "error_y": {"color": "#2a3f5f"}, "marker": {"line": {"color": "white", "width": 0.5}, "pattern": {"fillmode": "overlay", "size": 10, "solidity": 0.2}}, "type": "bar"}], "carpet": [{"aaxis": {"endlinecolor": "#2a3f5f", "gridcolor": "#C8D4E3", "linecolor": "#C8D4E3", "minorgridcolor": "#C8D4E3", "startlinecolor": "#2a3f5f"}, "baxis": {"endlinecolor": "#2a3f5f", "gridcolor": "#C8D4E3", "linecolor": "#C8D4E3", "minorgridcolor": "#C8D4E3", "startlinecolor": "#2a3f5f"}, "type": "carpet"}], "choropleth": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "type": "choropleth"}], "contourcarpet": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "type": "contourcarpet"}], "contour": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "colorscale": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]], "type": "contour"}], "heatmapgl": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "colorscale": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]], "type": "heatmapgl"}], "heatmap": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "colorscale": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]], "type": "heatmap"}], "histogram2dcontour": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "colorscale": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]], "type": "histogram2dcontour"}], "histogram2d": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "colorscale": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]], "type": "histogram2d"}], "histogram": [{"marker": {"pattern": {"fillmode": "overlay", "size": 10, "solidity": 0.2}}, "type": "histogram"}], "mesh3d": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "type": "mesh3d"}], "parcoords": [{"line": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "parcoords"}], "pie": [{"automargin": true, "type": "pie"}], "scatter3d": [{"line": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scatter3d"}], "scattercarpet": [{"marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scattercarpet"}], "scattergeo": [{"marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scattergeo"}], "scattergl": [{"marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scattergl"}], "scattermapbox": [{"marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scattermapbox"}], "scatterpolargl": [{"marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scatterpolargl"}], "scatterpolar": [{"marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scatterpolar"}], "scatter": [{"fillpattern": {"fillmode": "overlay", "size": 10, "solidity": 0.2}, "type": "scatter"}], "scatterternary": [{"marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scatterternary"}], "surface": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "colorscale": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]], "type": "surface"}], "table": [{"cells": {"fill": {"color": "#EBF0F8"}, "line": {"color": "white"}}, "header": {"fill": {"color": "#C8D4E3"}, "line": {"color": "white"}}, "type": "table"}]}, "layout": {"annotationdefaults": {"arrowcolor": "#2a3f5f", "arrowhead": 0, "arrowwidth": 1}, "autotypenumbers": "strict", "coloraxis": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "colorscale": {"diverging": [[0, "#8e0152"], [0.1, "#c51b7d"], [0.2, "#de77ae"], [0.3, "#f1b6da"], [0.4, "#fde0ef"], [0.5, "#f7f7f7"], [0.6, "#e6f5d0"], [0.7, "#b8e186"], [0.8, "#7fbc41"], [0.9, "#4d9221"], [1, "#276419"]], "sequential": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]], "sequentialminus": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]]}, "colorway": ["#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52"], "font": {"color": "#2a3f5f"}, "geo": {"bgcolor": "white", "lakecolor": "white", "landcolor": "white", "showlakes": true, "showland": true, "subunitcolor": "#C8D4E3"}, "hoverlabel": {"align": "left"}, "hovermode": "closest", "mapbox": {"style": "light"}, "paper_bgcolor": "white", "plot_bgcolor": "white", "polar": {"angularaxis": {"gridcolor": "#EBF0F8", "linecolor": "#EBF0F8", "ticks": ""}, "bgcolor": "white", "radialaxis": {"gridcolor": "#EBF0F8", "linecolor": "#EBF0F8", "ticks": ""}}, "scene": {"xaxis": {"backgroundcolor": "white", "gridcolor": "#DFE8F3", "gridwidth": 2, "linecolor": "#EBF0F8", "showbackground": true, "ticks": "", "zerolinecolor": "#EBF0F8"}, "yaxis": {"backgroundcolor": "white", "gridcolor": "#DFE8F3", "gridwidth": 2, "linecolor": "#EBF0F8", "showbackground": true, "ticks": "", "zerolinecolor": "#EBF0F8"}, "zaxis": {"backgroundcolor": "white", "gridcolor": "#DFE8F3", "gridwidth": 2, "linecolor": "#EBF0F8", "showbackground": true, "ticks": "", "zerolinecolor": "#EBF0F8"}}, "shapedefaults": {"line": {"color": "#2a3f5f"}}, "ternary": {"aaxis": {"gridcolor": "#DFE8F3", "linecolor": "#A2B1C6", "ticks": ""}, "baxis": {"gridcolor": "#DFE8F3", "linecolor": "#A2B1C6", "ticks": ""}, "bgcolor": "white", "caxis": {"gridcolor": "#DFE8F3", "linecolor": "#A2B1C6", "ticks": ""}}, "title": {"x": 0.05}, "xaxis": {"automargin": true, "gridcolor": "#EBF0F8", "linecolor": "#EBF0F8", "ticks": "", "title": {"standoff": 15}, "zerolinecolor": "#EBF0F8", "zerolinewidth": 2}, "yaxis": {"automargin": true, "gridcolor": "#EBF0F8", "linecolor": "#EBF0F8", "ticks": "", "title": {"standoff": 15}, "zerolinecolor": "#EBF0F8", "zerolinewidth": 2}}}, "annotations": [{"font": {"size": 15}, "showarrow": false, "text": "H: Alpha helix (4-12)", "x": 2.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "G: 3-10 helix", "x": 15.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "I: Pi helix", "x": 24.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "P: Poly-Proline helix", "x": 32.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "B: Isolated beta-bridge residue", "x": 45.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "E: Strand", "x": 63.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "-: None", "x": 71.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "S: Bend", "x": 79.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "T: Turn", "x": 87.5, "xanchor": "left", "y": 1}], "hovermode": false, "showlegend": false, "title": {"text": "Legend of secondary structures"}, "yaxis": {"visible": true, "showticklabels": false, "showline": true, "linewidth": 3, "linecolor": "black", "mirror": true, "showgrid": false, "zeroline": false}, "xaxis": {"visible": true, "showticklabels": false, "range": [-0.5, 93], "showline": true, "linewidth": 3, "linecolor": "black", "mirror": true, "showgrid": false, "zeroline": false}, "height": 110, "margin": {"t": 30, "b": 5, "pad": 0}}},
        }
    },
    methods: {
       defineColumns() {
          const width = window.innerWidth;

          // Define number of columns based on screen width
          if (width < 600) {
            this.prot_seq_cols = 1; // Mobile devices
          } else if (width >= 600 && width < 900) {
            this.prot_seq_cols = 2; // Small tablets
          } else if (width >= 900 && width < 1200) {
            this.prot_seq_cols = 3; // Tablets
          } else if (width >= 1200 && width < 1600) {
            this.prot_seq_cols = 4; // Medium screens
          } else {
            this.prot_seq_cols = 5; // Large screens
          }
        },
       format_protein_sequence(pseq) {
                    let mark_pos = false
                    if ("tag" in this.active_transcript) {
                        if (this.active_transcript.tag.includes("MANE_Select")) {
                            mark_pos = true
                        }
                    }

                    const prot_seq_length = 5

                    let pseq_arr = pseq.match(/.{1,10}/g);

                    let row_c = 0
                    let protloc = 0
                    let color='#e4eff2'
                    let arr_str = ''
                    let ic = 0
                    let rows = 0
                    let aa_section= 0
                    let pseq_str = ''
                    //let isVariant = false
                    let aa = ""
                    //alert(JSON.stringify(this.activeBiomarker))

                    pseq_str += '<div style="width:90%;margin:auto;padding:20px;background-color:#e4eff2;"><div style="margin:20px;">Seq'+this.active_transcript.transcript_id+' [organism=Homo sapiens] </div>'

                    pseq_str += '<table style="white-space: pre-wrap;font-family:monospace;margin:20px;width:600px;"><tr>'
                    //pseq_str += '<v-row style="width:100%;">'
                    //pseq_str += '<v-col cols="6" md="6" lg="2" xl="2" style="text-align:center;">'

                    for (let i = 0;i< pseq_arr.length; i += 1) {
                        aa_section = aa_section + 10

                        //pseq_str += '<v-col cols="6" md="6" lg="2" xl="2" style="border:1px solid red;text-align:center;">'
                        pseq_str += '<td style="white-space: pre-wrap;font-family:monospace;padding-right:40px;margin-left:10px;margin-right:30px;">'

                        pseq_str += '<table><tr><td style="text-align:right;color:#6a6a6a;">' + aa_section + '</td></tr><tr><td>'

                        arr_str = pseq_arr[i]
                        //pseq_str += pseq_arr[i]
                        for (let j =0;j<arr_str.length; j++) {
                            protloc++;
                            aa = arr_str[j]
                            color='#e4eff2'
                            pseq_str += '<span style="padding:2px;margin-left:2px; margin-right:2px;background-color:'+color+';">' + aa + '</span>'

                        }

                        pseq_str += '</td></tr></table>'
                        pseq_str +='</td>'
                        //pseq_str += '</v-col>'

                        row_c += 1
                        //protloc += 6
                        if (row_c == this.prot_seq_cols) {
                            rows++
                            pseq_str += '</tr><tr>'
                            //pseq_str += '</v-col><v-col>'
                            //pseq_str += '</v-row><v-row>'
                            //pseq_str += '<td>' + aa_section + '</td>'
                            row_c = 0
                        }
                    }
                    pseq_str += '</tr></table></div>'
                    //pseq_str += '</v-row>'
                    pseq_str +='</div>'
                    this.pseq = pseq_str
                    //alert(pseq_str)
                    return pseq_str
            },
        update_active_transcript(val) {
            for (let key of Object.keys(this.$store.getters.getActiveBiomarker)) {
                let activeBiomarker = this.$store.getters.getActiveBiomarker
                //alert(key + JSON.stringify(Object.keys(activeBiomarker)))
                this.active_transcript=this.$store.getters.getActiveBiomarker[key].gencode.transcripts[val]
                this.$store.dispatch("setActiveTranscript",this.active_transcript)
                //alert(JSON.stringify(this.active_transcript))
                //alert(this.active_transcript.transcript_id)
                this.loadProteinViewers()

                activeBiomarker = activeBiomarker[Object.keys(activeBiomarker)[0]]
                //alert(JSON.stringify(activeBiomarker))
                if ("gencode" in activeBiomarker) {
                    let pseq = activeBiomarker.gencode.MANE_Select_transcript
                    this.format_protein_sequence(this.active_transcript.protein_sequence)
                }
            }
        },
        async loadProteinData() {
            let url=this.$store.getters.getPathVariable('methods_generate_plot')
            let formData = new FormData();
            let variant_protein_data = {}

            variant_protein_data["UTA_Adapter"] = {}
            variant_protein_data["UTA_Adapter"]["gene_name"] = this.$store.getters.getActiveBiomarker[Object.keys(this.$store.getters.getActiveBiomarker)[0]]["gencode"]["gene"][0]["gene_name"]
            variant_protein_data["UTA_Adapter"]["variant_exchange"] = "R0W"
            //variant_protein_data["UTA_Adapter"]["variant_exchange"] = this.$store.getters.getActiveBiomarker[Object.keys(this.$store.getters.getActiveBiomarker)[0]]["UTA_Adapter"]["variant_exchange"]
            formData.append("variant_data", JSON.stringify(variant_protein_data) )
            formData.append("plot", "protein-data");

            await axios.post(url, formData, {
              headers: {
                "Content-Type": "text/html"
              }
            }).then((response) => {
                var response = response.data
                if (response.length > 0) {
                    try {
                        var graphJSON = response[0]["data"]["plot_json"]

                        Plotly.plot('protein_plot',graphJSON,graphJSON);
                        Plotly.plot('protein_legend',this.protein_legend,this.protein_legend)
                        this.$store.dispatch('setProcessState', [  "load-radar-0-thumb","" ] )
                    } catch (error) {
                        console.log(error)
                    }
                } else{
                    console.log("Error: Could not retrieve protein feature data")
                }
            })
        },
    async loadProteinViewers() {
            // Init 3D protein view
            //var pdbids = this.$store.getters.activeTranscript.pdb_ids
            var pdbid = this.active_protein
            let pdb_data = ""
            let patho_data = ""

            let activeBiomarker = this.$store.getters.getActiveBiomarker[Object.keys(this.$store.getters.getActiveBiomarker)[0]]

            let refAAMapping = {
                "A": "ALA",
                "R": "ARG",
                "N": "ASN",
                "D": "ASP",
                "C": "CYS",
                "Q": "GLN",
                "E": "GLU",
                "G": "GLY",
                "H": "HIS",
                "I": "ILE",
                "L": "LEU",
                "K": "LYS",
                "M": "MET",
                "F": "PHE",
                "P": "PRO",
                "S": "SER",
                "T": "THR",
                "W": "TRP",
                "Y": "TYR",
                "V": "VAL",
                "U": "SEC",
                "O": "PYL",
                "B": "ASX",
                "Z": "GLX",
                "X": "XAA"
            }



                let url = this.$store.getters.getPathVariable('methods_generate_plot')

                // get PDB data
                let qid = Object.keys(this.$store.getters.getActiveBiomarker)[0]
                let variant_data = {}
                 variant_data[qid] =  {
                    "UTA_Adapter": {"gene_name": activeBiomarker["gencode"]["gene"][0]["gene_name"] }
                }
                //alert(JSON.stringify(variant_data))

                let formData = new FormData();
                formData.append("plot", "pdb");
                formData.append("variant_data", JSON.stringify(variant_data))
                formData.append("qid", Object.keys(this.$store.getters.getActiveBiomarker)[0])

                await axios.post(url, formData, {
                    headers: {
                        "Content-Type": "text/html"
                    }
                }).then((response) => {
                    var response_data = response.data

                    try {
                        pdb_data = response_data[0].data.PDB_file_string
                        //alert(pdb_data)
                    } catch (error) {
                        console.log(error)
                    }

                })

            if (pdbid!=undefined) {
                let colorAsSnake = function(atom) {
                    return atom.resi % 2 == 0 ? 'white' : 'green';
                }

                try {

                    if (this.$refs.viewerContainer0) {
                        var viewer = $3Dmol.createViewer(this.$refs.viewerContainer0);
                        var viewer4 =  $3Dmol.createViewer(this.$refs.viewerContainer4);

                        //var molecule = viewer.addModel(data, "pdb");
                        var molecule = viewer.addModel(pdb_data, "pdb");
                        var molecule14 = viewer4.addModel(pdb_data, "pdb");
                        //alert(data)
                    }
                } catch (e) {
                    console.log(e)
                    }

                    //var getPathoColor = d3.scaleLinear()
                    //    .domain( [0,10,20,30] )
                    //    .range( ["white", "green", "yellow", "red"] )
                    let patho_arr = []

                    let am_url = this.$store.getters.getPathVariable('methods_get_am_region_scores')
                    let chrom = activeBiomarker["gencode"]["gene"][0][" seqname"].replace("chr","")
                    //alert(JSON.stringify(activeBiomarker["gencode_genomic"]["gene"]))
                    let pos_start = activeBiomarker["gencode"]["gene"][0][" start_pos"]
                    let pos_end = activeBiomarker["gencode"]["gene"][0][" end_pos"]
                    am_url = am_url + "?chrom=" + chrom + "&pos_start=" + pos_start + "&pos_end=" + pos_end


                //try {
                await axios.get(am_url, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }).then((response) => {
                    var response_data = response.data

                    try {
                        let gene_key = chrom + ":" + pos_start + "-" + pos_end
                        patho_data = response_data[gene_key]
                        //alert(JSON.stringify(patho_data))

                        //for (const [key, value] of Object.entries(patho_data)) {
                        //    alert(key + ":" + value)
                        //}
                    } catch (error) {
                        console.log(error)
                    }

                })
                //} catch (e) { console.error(e)}

                try {
                let prot_length = this.active_transcript["protein_sequence"].length
                for (let i = 0; i< prot_length; i++) {
                    if (String(i) in patho_data) {
                        //alert("pos found" + JSON.stringify(patho_data[String(i)]))
                        patho_arr.push(String(patho_data[String(i)]))
                    } else{
                        patho_arr.push(0.5)
                    }
                    //patho_arr.push(Math.random())
                }
                //alert(JSON.stringify(patho_arr))
                } catch(e) {
                    console.log(e)
                }

function Interpolate(start, end, steps, count) {
    var s = start,
        e = end,
        final = s + (((e - s) / steps) * count);
    return Math.floor(final);
}

function Color(_r, _g, _b) {
    var r, g, b;
    var setColors = function(_r, _g, _b) {
        r = _r;
        g = _g;
        b = _b;
    };

    setColors(_r, _g, _b);
    this.getColors = function() {
        var colors = {
            r: r,
            g: g,
            b: b
        };
        return colors;
    };
}

function perc2color(perc) {
	var r, g, b = 0;
	if(perc < 50) {
		//r = 255;
		b = 255
		r = Math.round(5.1 * perc);
		g = Math.round(5.1 * perc);
	}
	else {
		//g = 255;
		r = 255
		g = Math.round(510 - 5.10 * perc);
		b = Math.round(510 - 5.10 * perc);
	}
	//var h = r * 0x10000 + g * 0x100 + b * 0x1;
	var h = r * 0x10000 + g*0x100 + b * 0x1;
	//alert(h+","+r+","+g+","+b+","+0x100)

	var hex = function(x) {
        x = x.toString(16);
        return (x.length == 1) ? '0' + x : x;
    };
    //var r = Math.ceil(parseInt(color1.substring(0,2), 16) * ratio + parseInt(color2.substring(0,2), 16) * (1-ratio));
    //var g = Math.ceil(parseInt(color1.substring(2,4), 16) * ratio + parseInt(color2.substring(2,4), 16) * (1-ratio));
    //var b = Math.ceil(parseInt(color1.substring(4,6), 16) * ratio + parseInt(color2.substring(4,6), 16) * (1-ratio));


	//var h = r* 0x10000 + g*0x1 + b * 0x100
	return '#' + ('000000' + h.toString(16)).slice(-6);
}

                //alert(res_no)
                //for (let i=0; i<)
                let red = new Color(255, 0, 0)
                let white = new Color(255, 255, 255)
                let green = new Color(0, 0, 255)
                let start = green
                let end = white;

                var startColors = start.getColors(),
                    endColors = end.getColors();

                //var mutated_patho = "grey"


                var colorByPathogenicity = function(atom) {
                    //var c = getPathoColor( atom.b )
                    //return d3.rgb(c).hex()
                    //alert(JSON.stringify(atom.resi))

                    let patho = patho_arr[atom.resi]
                    //alert(patho)

                    let color = "#ffffff"
                    if (patho > 0.5) {
                        color = "#ab1828"
                    } else if (patho < 0.5) {
                        color = "#1861ab"
                    }

                    patho = patho*100
                    var r = Interpolate(startColors.r, endColors.r, 50, patho);
                    var g = Interpolate(startColors.g, endColors.g, 50, patho);
                    var b = Interpolate(startColors.b, endColors.b, 50, patho);
                    //let c = "rgb(" + r + "," + g + "," + b + ")"
                    let c = perc2color(patho)
                    //alert(c)

                    //alert(resi + ":: " + atom.resi)

                    return c
                }

                var colorMutatedPosition = function(atom) {
                    let patho = patho_arr[atom.resi]
                    //alert(patho)
                    let color = "#ffffff"
                    if (patho > 0.5) {
                        color = "#ab1828"
                    } else if (patho < 0.5) {
                        color = "#1861ab"
                    }

                    patho = patho*100
                    var r = Interpolate(startColors.r, endColors.r, 50, patho);
                    var g = Interpolate(startColors.g, endColors.g, 50, patho);
                    var b = Interpolate(startColors.b, endColors.b, 50, patho);
                    //let c = "rgb(" + r + "," + g + "," + b + ")"
                    let c = perc2color(patho)
                    //alert(c)

                    //alert(resi + ":: " + atom.resi)
                    if (parseInt(atom.resi) == parseInt(resi)) {
                        //alert(resi + ":" + patho + ":" + c)
                        return c
                    }
                    return "grey"
                }

                let colorCAAtom = function(atom) {

                    //alert(atom.atom + "::" + atom.resn + ";;" + resn + ":" + resi)
                    //return atom.resi % 2 == 0 ? 'white' : 'green';
                    //if ((atom.resi == resi) && (resn.localeCompare(atom.resn) == 0)) {
                    if (atom.atom.localeCompare("CA") == 0) {
                        return 'yellow'
                    } else {
                        return 'red'
                    }
                  };

                let colorCAAtom1 = function(atom) {
                    //alert(atom.atom + "::" + atom.resn + ";;" + resn + ":" + resi)
                    //return atom.resi % 2 == 0 ? 'white' : 'green';
                    //if ((atom.resi == resi) && (resn.localeCompare(atom.resn) == 0)) {
                    if (atom.atom.localeCompare("CA") == 0) {
                        return 'yellow'
                    } else {
                        return 'blue'
                    }
                  };

                try {
                    //molecule.setStyle({}, {cartoon: {color: "spectrum"}});
                    molecule.setStyle({}, {cartoon: {colorfunc: colorByPathogenicity }});
                    molecule14.setStyle({}, {cartoon: {colorfunc: colorByPathogenicity }});

                    var coordinates = this.getCAAtomCoordinates(pdb_data, resn, resi);
                    //alert("coord"+JSON.stringify(coordinates))
                } catch(error){
                console.log(error) }



                try {
                //viewer.addLabel(resn+resi, {position: coordinates, fontColor: "black", fontSize: 20, backgroundColor: "red", backgroundOpacity: 0.5});

                // configure viewer style and animation
                //viewer.addLabel(resn+resi, {position: {x:2.6, y:0.75, z:0.35}, fontColor: "black", fontSize: 20, backgroundColor: "red", backgroundOpacity: 0.5});
                viewer.setBackgroundColor('#ffffff');
                viewer4.setBackgroundColor('#ffffff');
                } catch(error) {
                    console.log(error)
                }

                //viewer.zoomTo({resn: resn, resi: resi});
                try {
                    if (this.$refs.viewerContainer0) {
                        viewer.render();
                        viewer4.render()
                        viewer.zoom(0.3, 1000);
                        viewer4.zoom(0.3, 1000);
                    }
                } catch (error) {
                    if (error.name === 'NS_ERROR_NOT_AVAILABLE') { alert(error.name) }
                        console.log(error)
                }


                // Get PDB binding site prediction data
                url = this.$store.getters.getPathVariable('methods_generate_plot')
                formData = new FormData();
                formData.append("plot", "pdb_scannet");

                //let qid = Object.keys(this.$store.getters.getActiveBiomarker)[0]
                //let variant_data = {}
                // variant_data[qid] =  {
                //    "UTA_Adapter": {"gene_name": activeBiomarker["gencode"]["gene"][0]["gene_name"] }
                //}

                formData.append("variant_data", JSON.stringify({"pdb":pdb_data,"protein": activeBiomarker["gencode"]["gene"][0]["gene_name"] }))
                //formData.append("variant_data", JSON.stringify(pdb_data))
                formData.append("qid", activeBiomarker["gencode"]["gene"][0]["gene_name"] )
                let pdb_data_scannet = ""
                //} catch (e) { console.error(e)}

                try {
                await axios.post(url, formData, {
                    headers: {
                        "Content-Type": "text/html"
                    }
                }).then((response) => {
                    var response_data = response.data

                    try {
                        pdb_data_scannet = response_data["pdb"]
                        //alert(JSON.stringify(pdb_data_scannet))
                    } catch (error) {
                        console.log(error)
                    }

                })

                } catch(e) {
                    console.log(e)
                }




                try {
                    if (this.$refs.viewerContainer1) {
                        var viewer1 = $3Dmol.createViewer(this.$refs.viewerContainer1);
                        var viewer5 = $3Dmol.createViewer(this.$refs.viewerContainer5);
                        //var molecule = viewer.addModel(pdb_data_scannet, "pdb");
                        let config = { backgroundColor: '#ffffff' }
                        var molecule1 = viewer1.addModel(pdb_data_scannet, "pdb");
                        var molecule15 = viewer5.addModel(pdb_data_scannet, "pdb");

                        var getBfactorColour = function(bfactor) {
                            return
                        }

                        var colorByBFactor = function(atom) {
                            var c = getBfactorColour( atom.b );
                            //console.log( "atom:", atom.hetflag, atom.b, c, d3.rgb( c ).hex() );
                            return d3.rgb( c ).hex();
                        };
                    }
                } catch (error) {
                        console.log(error)
                }

                    //molecule1.setStyle({}, {cartoon: {colorfunc: colorByBFactor}});

                try {
                    if (this.$refs.viewerContainer1) {
                        var colorGradient = new $3Dmol.Gradient.RWB(0,0.7);
                        // Color atoms based on B-factor values
                        //viewer1.setStyle({}, {cartoon: "none"});
                        //var gradient = new $3Dmol.Gradient.RWB($3Dmol.getPropertyRange(viewer1.selectedAtoms(),'b'));

                        var gradient = new $3Dmol.Gradient.RWB(0,0.7);
                        //var selection = {resi: resi};
                        viewer1.addSurface($3Dmol.SurfaceType.VDW, {colorscheme: {prop: 'b', gradient: gradient},opacity: 1.0}, {
                        });
                        viewer5.addSurface($3Dmol.SurfaceType.VDW, {colorscheme: {prop: 'b', gradient: gradient},opacity: 1.0}, {
                        });

                        viewer1.addSurface($3Dmol.SurfaceType.VDW, {
                            opacity: 0.6,  // Low opacity for the selected range
                            color: 'white',
                            colorscheme: {prop: 'b', gradient: gradient}
                        }, selection);
                        viewer5.addSurface($3Dmol.SurfaceType.VDW, {
                            opacity: 0.6,  // Low opacity for the selected range
                            color: 'white',
                            colorscheme: {prop: 'b', gradient: gradient}
                        }, selection);
                    }
                } catch (error) {
                    console.log(error)
                }

                try {
                    if (this.$refs.viewerContainer1) {
                        //molecule1.setStyle({}, {cartoon: {colorfunc: colorByPathogenicity }});
                        molecule1.setStyle({}, {cartoon: {colorscheme: {prop: 'bfactor'} }});
                        viewer1.setStyle({}, {cartoon: {colorscheme: {prop: 'bfactor', gradient: 'roygb', min: 0, max: 0.7}}});
                        //viewer1.setStyle({}, {surface: {colorscheme: {prop: 'bfactor', gradient: 'roygb', min: 0, max: 0.7}}})
                        //viewer1.addLabel(resn+resi, {position: coordinates, fontColor: "black", fontSize: 20, backgroundColor: "red", backgroundOpacity: 0.5});
                        //viewer5.addLabel(resn+resi, {position: coordinates, fontColor: "black", fontSize: 20, backgroundColor: "red", backgroundOpacity: 0.5});

                        //viewer.setStyle({resi: "*", b: [0, 0.7]}, {cartoon: "none", colorfunc: function(atom) {
                        //    return colorGradient.valueToHex(atom.b);
                        //}});

                        molecule1.setStyle({resi: resi}, {stick: {color: "red", thickness: 2.0}});
                        molecule15.setStyle({resi: resi}, {stick: {color: "red", thickness: 2.0}});
                        // configure viewer style and animation
                        viewer1.setBackgroundColor('#ffffff');
                        viewer5.setBackgroundColor('#ffffff');
                        //viewer1.zoomTo({resn: resn, resi: resi});


                            viewer1.zoomTo({resi:resi})
                            viewer5.zoomTo({resi:resi})

                            viewer1.render();
                            viewer5.render();

                            viewer1.zoom(0.3, 1000);
                            viewer5.zoom(0.3, 1000);
                    }
                } catch (error) {
                    console.log(error)
                }

            } else {
                try {
                    if (this.$refs.viewerContainer1) {
                        var viewer = $3Dmol.createViewer(this.$refs.viewerContainer0);
                        var viewer1 = $3Dmol.createViewer(this.$refs.viewerContainer1);
                        let config2 = { backgroundColor: '#ffffff' }
                        var viewer2 = $3Dmol.createViewer(this.$refs.viewerContainer2, config2);
                        var viewer4 = $3Dmol.createViewer(this.$refs.viewerContainer4, config2);
                        var viewer5 = $3Dmol.createViewer(this.$refs.viewerContainer5, config2);
                        var viewer6 = $3Dmol.createViewer(this.$refs.viewerContainer6, config2);
                    }
                } catch(error) {console.log(error)}
            }
        }

    },
    created: async function () {
        this.isLoading=true
        this.$store.dispatch("setIsLoading", true)

        await active_variants.loadActiveBiomarkerGene(this.$route.params.id)
        this.isLoading=false
        //alert(JSON.stringify(this.$store.getters.getActiveBiomarker))

        //for (const [key,item] of Object.entries(this.$store.getters.getActiveBiomarker)) {

        await this.loadProteinData()
        let activeBiomarker = this.$store.getters.getActiveBiomarker
        activeBiomarker = activeBiomarker[Object.keys(activeBiomarker)[0]]

        this.defineColumns()
        if ("gencode" in activeBiomarker) {
            await this.update_active_transcript(activeBiomarker.gencode.MANE_Select_transcript)
            //this.loadProteinViewers()
            await this.loadProteinData()
        }
        //}
        this.isLoading = false
        this.$store.dispatch("setIsLoading", false)
    },
}
</script>
<style>
</style>